import { Navigate, Route, Routes } from 'react-router-dom';
import PMDashboardPage from './PMDashboardPage';
import ProjectsPage from './ProjectsPage';
import BoardPage from './BoardPage';
import TeamPage from './TeamPage';

export default function ProjectManagementRoutes() {
  return (
    <Routes>
      <Route index element={<PMDashboardPage />} />
      <Route path="projects" element={<ProjectsPage />} />
      <Route path="board" element={<BoardPage />} />
      <Route path="team" element={<TeamPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
